<template>
    <div class="template-default one-column-layout" :style="fixed? '' : 'padding-top: 0!important'">
        <div class="top" :style="fixed? '' : 'position: unset'">
            <slot name="top"></slot>
            <div :class="`${isMobile? '' : 'container'} component-navbar d-md-flex justify-content-md-between`">
                <Logo/>
                <h2 v-if="!isMobile" class="mt-1">{{title}}</h2>
                <h3 v-else class="mt-2 text-right mr-2">{{title}}</h3>
                <div class="mt-1">
                    <slot name="header"></slot>
                </div>
            </div>
        </div>
        <div class="container">
            <main>
                <div class="pt-4">
                    <slot></slot>
                </div>
            </main>
        </div>
        <footer>
            <Footer/>
        </footer>
    </div>
</template>

<script>
import Navbar from './default/Navbar'
import Logo from '../../pages/layout/default/Logo'
import Footer from './common/Footer'
import WarningImplementation from '../../common/WarningImplementation'
import ArrowBreadcrumbs from '../../widgets/common/ArrowBreadcrumbs'
import Header from '../../widgets/pages/tour-accompagnati/layout/Header'
import MobileDetector from '../../common/MobileDetector'

export default {
  name: 'OneColumnLayout',
  mixins: [MobileDetector],
  components: {Header, ArrowBreadcrumbs, WarningImplementation, Footer, Logo, Navbar},
  props: {
    title: {
      type: String,
      value: ''
    },
    fixed: {
      type: Boolean,
      value: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/OneColumLayout.vue